import React from 'react';
import { Link } from 'react-router-dom';

import logoUrl from '../../logo.png';
import './header.css';

type HeaderProps = {
  // Shown in the pill on the right, e.g. the room code.
  roomCode?: string;
};

export const Header = ({ roomCode }: HeaderProps) => {
  const brand = (
    <>
      <img className='headerLogo' src={logoUrl} alt='' />
      <span className='headerText'>Icebreaker</span>
    </>
  );

  return (
    <div className='roomHeader'>
      {roomCode
        ? <div className='brand'>{brand}</div>
        : <Link className='brand' to='/'>{brand}</Link>}
      {roomCode
        ? <span className='roomCodePill'>{`Room ${roomCode}`}</span>
        : (
          <Link className='galleryNav' to='/gallery'>
            Gallery
          </Link>
          )}
    </div>
  );
};
